import * as React from "react"
import {
    IChangeFilePositionPayload,
    IDeleteFilePayload,
    IRestoreFilePayload,
    ProductFormActions,
    getActions,
} from "./_actions"
import {arePropsSimilar, useEventCallback} from "../../utils/memo"

const noop = () => undefined
import {
    $getProductPreviousVersions,
    $updateDeclinedProduct,
    $updateProduct,
    $validateProduct,
    isHttpError,
} from "../../core/requests"
import {
    hasAtLeastSelectedOneDeclination,
    Languages,
    preventExistingIdReferenceCreation,
    Roles,
} from "../../utils"
import {
    checkFieldValidity,
    checkFileProps,
    checkFieldsValidity,
    ITranslations,
    permanentFormIds,
    ISupplierReference,
    IRawSupplierReference,
    ISupplierInfo,
    checkFilePresenceForRestore,
    IHandleChangeProps,
    FieldType,
    completeDeclined,
    ISupplierDeclinedReference,
} from "../../models"
import {
    Button,
    Divider,
    Dropdown,
    DropdownProps,
    Label,
    Modal,
    Popup,
} from "semantic-ui-react"
import PicturesContainer, {
    PicturePreviousVersion,
} from "../components/form-field-file-containers/com_picture-container"
import CommonFields from "../components/form-field-containers/com_common-fields"
import UncommonFields from "../components/form-field-containers/com_uncommon-fields"
import SideBar from "../components/form-field-sidebar/com_sidebar"
import IVat from "../../models/product/vat"
import ICustoms from "../../models/product/customs"
import {
    IDropdownOption,
    IFieldState,
} from "./_reducers/_utils/product-form-types"
import FileContainer, {
    FilePreviousVersion,
} from "../components/form-field-file-containers/com_file-container"
import ITerritoi from "../../models/product/territoi"
import {toastr} from "react-redux-toastr"
import {getFormDataFromFields, stopLoading} from "../../core/actions"
import Loading from "../components/com_loading"
import formIdReducer, {
    IPreviousVersions,
    IStandardFields,
    ITechFields,
} from "./_reducers/form-id-state"
import {
    deleteDoublonComplex,
    haveArraysTheSameOrder,
} from "../../utils/doublon-tools"
import {createFormFieldByCaratech} from "./_reducers/_utils/create-field"
import {ITechRawData} from "../../models/bo"
import moment from "moment"

export interface IDeclinedFormProps {
    selectedSupplier: ISupplierInfo
    activeLang: Languages
    role: Roles
    techFieldsRawData: ITechRawData[]
    translations: ITranslations["productForm"]
    errorTranslations: ITranslations["fieldErrors"]
    products: IRawSupplierReference[]
    onCloseWithoutSave: () => void
    onCloseWithSave: () => void
    topRef: ISupplierReference | null
    declinedDroopyId?: string
}

const inputPicture: any = React.createRef()
const inputPdf: any = React.createRef()

const handleFocusInputPicture = (e: any) => {
    e.preventDefault()
    if (inputPicture && inputPicture.current && inputPicture.current) {
        inputPicture.current.click()
    }
}

const handleFocusInputPdf = (e: any) => {
    e.preventDefault()
    if (inputPdf && inputPdf.current && inputPdf.current) {
        inputPdf.current.click()
    }
}

const DeclinedForm = ({
                          activeLang,
                          products,
                          role,
                          translations,
                          errorTranslations,
                          selectedSupplier,
                          techFieldsRawData,
                          topRef,
                          declinedDroopyId,
                          onCloseWithoutSave,
                          onCloseWithSave,
                      }: IDeclinedFormProps) => {
    const [controller, setController] = React.useState<AbortController>()
    const [state, dispatch] = React.useReducer(
        formIdReducer,
        formIdReducer({} as any, {} as any)
    )
    const [loading, setLoading] = React.useState(false)

    const {
        standardFields,
        techFields,
        product,
        deletedFileNames,
        previousVersions,
        selectedPreviousVersion,
    } = state
    // const product = React.useMemo(() => {
    //   if (!topRef) {
    //     return null
    //   }
    //   const declined = topRef.declined?.find(
    //     (x) => x.droopyId === declinedDroopyId
    //   )
    //   if (!declined) {
    //     return null
    //   }
    //   return completeDeclined(topRef, declined)
    // }, [declinedDroopyId, topRef])
    const _previousVersion = selectedPreviousVersion
        ? previousVersions[selectedPreviousVersion]
        : null
    const previousVersion =
        _previousVersion && _previousVersion !== "loading"
            ? _previousVersion
            : undefined
    const allFields: { [fieldName: string]: IFieldState<any> } = {
        ...standardFields,
        ...techFields,
    }
    const {pictures, pdf, isTopRef, droopyId, validated} = standardFields
    const actions = React.useMemo(() => getActions(dispatch), [dispatch])

    React.useEffect(() => {
        handleResetForm()
    }, [declinedDroopyId, topRef])

    React.useEffect(() => {
        if (!product || techFieldsRawData.length <= 0) {
            return
        }
        const techF = techFieldsRawData.map((rawData) =>
            createFormFieldByCaratech(rawData)
        )
        const declinationOptions = techFieldsRawData
            .filter((x) => x.isDeclinable && x.type === "select")
            .map((x) => ({text: x.label, key: x.codeEnum, value: x.codeEnum}))
        actions._updateDeclinationList(declinationOptions)

        actions._storeTechFields("", {
            fields: techF,
            rawData: techFieldsRawData,
            techValues: product.techFields,
        })
    }, [
        actions,
        product,
        product?.techFields,
        product?.techNode,
        standardFields.techNode.value.code,
        techFieldsRawData,
    ])

    React.useEffect(() => {
        if (!declinedDroopyId || !product) {
            return
        }
        const onStorePreviousVersion = (
            p: ISupplierDeclinedReference,
            d: string
        ) => {
            const toStore = completeDeclined(product, p)
            actions._storePreviousVersion("", toStore, d)
        }

        if (role === Roles.MARKET_LEADER) {
            const c = new AbortController()
            setController(c)
            $getProductPreviousVersions(
                declinedDroopyId,
                product.previousVersionDates,
                "declined",
                onStorePreviousVersion,
                c.signal
            )
        } else {
            const d = moment().format("YYYY-MM-DD HH:mm:ss")
            actions._storePreviousVersion("", product, d)
            actions._selectPreviousVersion("", d)
        }
    }, [declinedDroopyId, product, role])

    let tabIndex = 1

    const handleChangeField = useEventCallback((
        {
            code,
            fieldType,
            lock,
            fieldValue,
            overrideDefaultValue = false,
            forceAcceptEmptyArray = false,
        }: IHandleChangeProps,
        ignoreError = false
    ) => {
        const field =
            fieldType === FieldType.Standard ? standardFields[code] : techFields[code]
        if (
            field !== undefined &&
            ((fieldValue !== undefined && fieldValue !== field.value) ||
                lock !== field.lock)
        ) {
            const value =
                fieldValue !== undefined &&
                fieldValue !== null &&
                fieldValue !== "-1" &&
                (!(Array.isArray(fieldValue) && fieldValue.length === 0) || forceAcceptEmptyArray)
                    ? fieldValue
                    : field.value

            const errorMessage = (ignoreError || (code == "ean" && !selectedSupplier.eanMandatory))
                ? ""
                : checkFieldValidity({
                    field: {...field, value},
                    translations: errorTranslations,
                })

            actions._onChangeField("", {
                code,
                fieldValue: value,
                fieldType,
                lock,
                errorMessage,
                overrideDefaultValue,
            })
        }
    })

    const handleChangeFile: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        if (e.target?.files?.length === 0) {
            return
        }
        setLoading(true)
        const code = e.target?.name
        const files = standardFields[code].value

        const queue = Array.from(e.target?.files || [])
        queue.forEach((file: File) => {
            if (checkFileProps(file, files, code, translations)) {
                // Display-only URL: the file itself is sent on save (no base64 copy in memory).
                actions._createFile("", {
                    code,
                    file,
                    blob: URL.createObjectURL(file),
                    name: file.name,
                    isNew: true,
                })
            }
        })
        setLoading(false)
    }

    const handleDeleteFile = useEventCallback((payload: IDeleteFilePayload) =>
        actions._deleteFile("", payload))

    const handleRestoreFile = useEventCallback((payload: IRestoreFilePayload) => {
        const files = standardFields[payload.code].value
        if (checkFilePresenceForRestore(payload.fileInfos, files, translations)) {
            actions._restoreFile("", payload)
        }
    })

    const handleChangeFilePosition = useEventCallback((payload: IChangeFilePositionPayload) =>
        actions._changeFilePosition("", payload))

    const isProductValid = (): boolean => {
        const fields = {...standardFields, ...techFields}
        const notRequiredList = [
            "declined",
            "declination",
            "comNode",
            "techNode",
            "declinedToAdd",
            "brand",
            !selectedSupplier.eanMandatory ? "ean" : "",
        ]
        const errorMessages = checkFieldsValidity({
            fields,
            notRequiredList,
            translations: {...translations, ...errorTranslations},
        })
        actions._setErrorMessages("", errorMessages)

        if (Object.keys(errorMessages).length > 0) {
            const errorLabels = Object.keys(errorMessages).map(
                (e) => translations[allFields[e].label + "FieldLabel"] || allFields[e].label || e
            )
            toastr.error(
                "Le(s) champ(s) suivant(s) sont en erreur :",
                errorLabels.join(", ")
            )
            return false
        }

        return true
    }

    const areIdsFree = (): boolean => {
        if (
            !isTopRef.value &&
            // isNewProduct &&
            preventExistingIdReferenceCreation(
                products,
                standardFields.ean.value,
                standardFields.supplierRef.value,
                ""
            )
        ) {
            toastr.error(translations.productAlreadyCreated, "")
            return false
        }
        return true
    }

    const handleSubmit = (event: React.SyntheticEvent) => {
        event.preventDefault()
        updateDeclinedProduct()
    }

    const updateDeclinedProduct = (isValidation = false) => {
        if (!isProductValid() || !areIdsFree()) {
            return new Promise((re) => re(""))
        }
        setLoading(true)
        const caraTechOptions = Object.keys(techFields).reduce((acc, k) => {
            const o = techFields[k].options
            return o.length > 0 ? {...acc, [k]: o} : acc
        }, {} as { [key: string]: IDropdownOption[] })

        actions._startSubmitting()
        controller?.abort()
        formRef.current?.scrollTo({top: 0, behavior: "smooth"})
        const formData = getFormDataFromFields(
            standardFields,
            techFields,
            techFieldsRawData,
            caraTechOptions,
            role,
            deletedFileNames
        )
        formData.append("topRef", topRef?.supplierRef || "")
        formData.append("topDroopyId", topRef?.droopyId || "")

        return $updateDeclinedProduct(
            formData,
            product?.supplierRef || standardFields.supplierRef.value
        )
            .then((res) => res.json())
            .then((r) => {
                if (!isValidation) {
                    toastr.success(translations.registerProductSuccess || "Produit enregistré", "")
                    onCloseWithSave()
                }
            })
            .catch((err) => {
                // HTTP errors are already displayed by $myFetch.
                if (!isHttpError(err)) {
                    toastr.error(
                        translations.cantFetchServer ||
                        "L'enregistrement a échoué : impossible de joindre le serveur.",
                        ""
                    )
                }
            })
            .finally(() => {
                actions._stopSubmitting()
                setLoading(false)
            })
    }

    const handleResetForm = (e?: React.SyntheticEvent) => {
        e?.preventDefault()
        const locked = Object.keys(allFields).map((f) =>
            allFields[f].lock === "lock" ? f : ""
        )
        actions._resetForm("", {locked, previousVersions})
        actions._storeDeclined({
            topRef: topRef as ISupplierReference,
            declinedDroopyId: declinedDroopyId as string,
        })
    }

    const handleValidateProduct = (event: React.SyntheticEvent) => {
        event.preventDefault()
        if (!isProductValid() || !areIdsFree()) {
            return
        }
        setLoading(true)
        $validateProduct(
            topRef?.droopyId || "",
            role,
            product?.droopyId,
            selectedSupplier.supplierName
        )
            .then(() => {
                setLoading(false)
                onCloseWithSave()
            })
            // The error message is displayed by $myFetch; the modal stays open.
            .catch(() => setLoading(false))
    }

    const onFieldLooseFocus = noop
    const loadingText = ""
    const formRef = React.useRef<HTMLDivElement>(null)

    return (
        <div className="product-view">
            <h1 className="page-title">{translations.modifyProductMainTitle}</h1>
            <form onSubmit={handleSubmit} className="product-form">
                <div className="product-form-div">
                    <div
                        className="inputs-container"
                        ref={formRef}
                        style={loading ? {overflow: "hidden"} : undefined}
                    >
                        {loading && <Loading text={loadingText}/>}
                        <div className="form-inputs">
                            <h2 className="form-title"> {translations.caracTitle} </h2>
                            <UncommonFields
                                lockable={true}
                                previousVersion={previousVersion}
                                activeLang={activeLang}
                                tabIndex={tabIndex++}
                                isNewProduct={false}
                                translations={translations}
                                boolTopRef={isTopRef.value}
                                ean={standardFields.ean}
                                manufacturerRef={standardFields.manufacturerRef}
                                supplierRef={standardFields.supplierRef}
                                handleChangeStandardField={handleChangeField}
                                handleStandardFieldLockClick={undefined}
                                onFieldLooseFocus={onFieldLooseFocus}
                                selectedPreviousVersion={selectedPreviousVersion}
                            />
                            <CommonFields
                                supplier={selectedSupplier}
                                lockable={true}
                                previousVersion={previousVersion}
                                selectedPreviousVersion={selectedPreviousVersion}
                                tabIndex={tabIndex + 3}
                                isVariant={true}
                                isMarketLeader={role === Roles.MARKET_LEADER}
                                comNodeDisabledMessage={translations.comNodeDisabledVariant}
                                techNodeDisabledMessage={translations.techNodeDisabledVariant}
                                techFieldsIsLoading={false}
                                handleChangeField={handleChangeField}
                                onFieldLooseFocus={onFieldLooseFocus}
                                vatOptionList={undefined as any}
                                warrantyOptionList={undefined as any}
                                taxesList={undefined as any}
                                customsOptionList={undefined as any}
                                territoiOptionList={undefined as any}
                                brandOptionList={undefined as any}
                                onFieldLockClick={undefined as any}
                                comPropNodes={undefined as any}
                                techPropNodes={undefined as any}
                                formId=""
                                {...{
                                    standardFields,
                                    techFields,
                                    techRawData: techFieldsRawData,
                                    translations,
                                    activeLang,
                                }}
                            />
                        </div>
                    </div>
                    <div className="pictures-container">
                        {loading && (
                            <Loading style={{marginLeft: "-2em", width: "105%"}}/>
                        )}
                        <div>
                            <input
                                ref={inputPicture}
                                type="file"
                                accept="image/*"
                                name="pictures"
                                onChange={handleChangeFile}
                                style={{display: "none"}}
                                multiple
                            />
                        </div>
                        <div>
                            <Label
                                as="a"
                                className="button colored-button"
                                ribbon
                                onClick={handleFocusInputPicture}
                            >
                                {translations.addImageButtonLabel}
                            </Label>
                            {previousVersion &&
                                selectedPreviousVersion &&
                                !haveArraysTheSameOrder(
                                    deleteDoublonComplex(previousVersion.pictures, "name"),
                                    pictures.value,
                                    "name"
                                ) &&
                                PicturePreviousVersion(
                                    pictures.code,
                                    handleRestoreFile,
                                    selectedPreviousVersion,
                                    previousVersion
                                )}
                        </div>

                        <PicturesContainer
                            onDeleteFile={handleDeleteFile}
                            onChangeFilePosition={handleChangeFilePosition}
                            code={pictures.code}
                            files={pictures}
                            error={pictures.errorText}
                        />
                        <div>
                            <input
                                ref={inputPdf}
                                accept="application/pdf"
                                type="file"
                                name="pdf"
                                onChange={handleChangeFile}
                                style={{display: "none"}}
                                multiple
                            />
                        </div>
                        <div style={{position: "relative"}}>
                            <Label
                                as="a"
                                className="button colored-button"
                                ribbon
                                onClick={handleFocusInputPdf}
                            >
                                {translations.addPdfButtonLabel}
                            </Label>
                            {previousVersion &&
                                selectedPreviousVersion &&
                                !haveArraysTheSameOrder(
                                    deleteDoublonComplex(previousVersion.pdf, "name"),
                                    pdf.value,
                                    "name"
                                ) &&
                                FilePreviousVersion(selectedPreviousVersion, previousVersion)}
                        </div>

                        <FileContainer
                            onDeleteFile={handleDeleteFile}
                            onChangeFilePosition={handleChangeFilePosition}
                            code={pdf.code}
                            files={pdf}
                            error={pdf.errorText}
                        />
                    </div>
                </div>
                <Divider fitted/>
                <div className="form-buttons">
                    <CommonButtons
                        product={product}
                        translations={translations}
                        handleResetForm={handleResetForm}
                        loading={loading}
                        loadCaratech={false}
                        isNewProduct={false}
                    />
                    <MarketLeaderButtons
                        role={role}
                        product={product}
                        translations={translations}
                        handleValidateProduct={handleValidateProduct}
                        selectedPreviousVersion={selectedPreviousVersion}
                        previousVersions={previousVersions}
                        isNewProduct={false}
                        productAlreadyValidated={validated.value}
                        actions={actions}
                        formId={""}
                    />
                </div>
            </form>
        </div>
    )
}

interface ISafeGuardPopupProps {
    disabled: boolean
    translations: ITranslations["productForm"]
}

const SafeGuardPopup = (
    props: React.PropsWithChildren<ISafeGuardPopupProps>
) => (
    <Popup
        position="top center"
        trigger={props.children}
        disabled={props.disabled}
        cenete
        content={
            <div style={{textAlign: "center"}}>
                {props.translations.cannotInteractWithDeletedProduct}
            </div>
        }
    />
)

interface IMarketLeaderButtons {
    role: Roles
    product: ISupplierReference | null
    translations: ITranslations["productForm"]
    handleValidateProduct: (event: React.SyntheticEvent) => void
    isNewProduct: boolean
    productAlreadyValidated: boolean
    previousVersions: IPreviousVersions
    selectedPreviousVersion: string | null
    actions: ProductFormActions
    formId: string
}

const MarketLeaderButtons = ({
                                 role,
                                 product,
                                 translations,
                                 handleValidateProduct,
                                 previousVersions,
                                 selectedPreviousVersion,
                                 isNewProduct,
                                 productAlreadyValidated,
                                 actions,
                                 formId,
                             }: IMarketLeaderButtons) => {
    const previousVersionOptions = React.useMemo(
        () =>
            product?.previousVersionDates?.reduce(
                (acc, d) => [
                    ...acc,
                    {
                        key: d,
                        value: d,
                        text: new Date(d).toLocaleDateString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                        }),
                        selected: d === selectedPreviousVersion,
                    },
                ],
                [] as Array<{ key: string; value: string; text: string }>
            ) || [
                {key: "no-date", value: "no-date", text: "Aucune version précédente"},
            ],
        [product?.previousVersionDates]
    )

    const onChange = (_: any, b: DropdownProps) => {
        actions._selectPreviousVersion(formId, b.value + "")
    }

    const text =
        product?.previousVersionDates && product?.previousVersionDates.length > 0
            ? new Date(selectedPreviousVersion + "").toLocaleDateString([], {
                hour: "2-digit",
                minute: "2-digit",
            })
            : "Aucune version précédente"

    return (
        <div className="market-leader-buttons">
            {role === Roles.MARKET_LEADER ? (
                <>
                    <SafeGuardPopup
                        disabled={!(product && product.deleted)}
                        translations={translations}
                    >
                        <div>
                            <Button
                                onClick={handleValidateProduct}
                                className="element button marketLeaderButton"
                                disabled={
                                    isNewProduct ||
                                    productAlreadyValidated ||
                                    !!(product && product.deleted)
                                }
                            >
                                {productAlreadyValidated
                                    ? translations.alreadyValidatedProductCdmLabel
                                    : translations.validateProductCdmLabel}
                            </Button>
                        </div>
                    </SafeGuardPopup>
                    <SafeGuardPopup
                        disabled={!(product && product.deleted)}
                        translations={translations}
                    >
                        <div className="previous-version-dropdown">
              <span>
                Comparer avec{" "}
                  <Dropdown
                      inline
                      loading={
                          previousVersions[selectedPreviousVersion + ""] ===
                          ("loading" || undefined)
                      }
                      options={previousVersionOptions}
                      value={selectedPreviousVersion || "no-date"}
                      onChange={onChange}
                      text={text}
                      selectOnBlur={false}
                      selectOnNavigation={false}
                  />
              </span>
                        </div>
                    </SafeGuardPopup>
                </>
            ) : (
                ""
            )}
        </div>
    )
}

interface ICommonButtons {
    product: ISupplierReference | null
    translations: ITranslations["productForm"]
    handleResetForm: (
        e?: React.SyntheticEvent<Element, Event> | undefined
    ) => void
    loading: boolean
    loadCaratech: boolean
    isNewProduct: boolean
}

const CommonButtons = ({
                           product,
                           translations,
                           handleResetForm,
                           loading,
                           loadCaratech,
                           isNewProduct,
                       }: ICommonButtons) => {
    return (
        <div className="common-buttons">
            <SafeGuardPopup
                disabled={!(product && product.deleted)}
                translations={translations}
            >
                <div>
                    <Button
                        type="submit"
                        disabled={!!(product && product.deleted) || loadCaratech || loading}
                        className="element button filled colored-button"
                    >
                        {translations.validationButtonLabel}
                    </Button>
                </div>
            </SafeGuardPopup>
            <SafeGuardPopup
                disabled={!(product && product.deleted)}
                translations={translations}
            >
                <div>
                    <Button
                        onClick={handleResetForm}
                        className="element button colored-button"
                        disabled={!!(product && product.deleted) || loading}
                    >
                        {!isNewProduct
                            ? translations.cancelModification
                            : translations.resetButtonLabel}
                    </Button>
                </div>
            </SafeGuardPopup>
        </div>
    )
}

const DeclinedModal = React.memo((props: IDeclinedFormProps) => {
    const opened = !!props.topRef && !!props.declinedDroopyId
    return (
        <Modal
            open={opened}
            size="fullscreen"
            className="declined-modal"
            onClose={props.onCloseWithoutSave}
            content={<DeclinedForm {...props} />}
        />
    )
}, arePropsSimilar)

export default DeclinedModal
